module.exports = __webpack_public_path__ + "static/media/2.5a234e09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/firebase/2.jpg
// module id = 100
// module chunks = 0